import { Link } from 'react-router-dom';
import type { NewsArticle } from '@/types';

interface NewsCardProps {
  article: NewsArticle;
  variant?: 'list' | 'card';
}

export default function NewsCard({ article, variant = 'card' }: NewsCardProps) {
  if (variant === 'list') {
    return (
      <Link
        to={`/news/${article.id}`}
        className="group flex flex-col gap-4 rounded-lg border border-background-200 bg-background-50 p-3 transition-all duration-300 hover:border-primary-200 hover:shadow-sm sm:flex-row sm:p-4"
      >
        <div className="h-44 w-full shrink-0 overflow-hidden rounded-md bg-background-200 sm:h-[132px] sm:w-52">
          <img
            src={article.cover}
            alt={`${article.title} 配图`}
            title={article.title}
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
        </div>
        <div className="flex flex-1 flex-col">
          <div className="flex flex-wrap items-center gap-2 text-xs text-foreground-500">
            <span className="rounded bg-accent-100 px-2 py-0.5 text-accent-800">{article.topic}</span>
            <span className="flex items-center gap-1">
              <i className="ri-calendar-line" />
              {article.date}
            </span>
          </div>
          <h3 className="mt-2 line-clamp-2 font-heading text-base font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600 md:text-lg">
            {article.title}
          </h3>
          <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-500">{article.summary}</p>
          <span className="mt-auto flex items-center gap-1 pt-3 text-sm text-primary-600">
            阅读全文
            <i className="ri-arrow-right-s-line" />
          </span>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/news/${article.id}`}
      className="group flex w-[260px] shrink-0 flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all duration-300 hover:border-primary-200 sm:w-[280px]"
    >
      <div className="h-40 w-full overflow-hidden bg-background-200">
        <img
          src={article.cover}
          alt={`${article.title} 配图`}
          title={article.title}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="flex flex-1 flex-col gap-2 p-3.5">
        <span className="text-xs text-accent-700">{article.topic}</span>
        <h3 className="line-clamp-2 font-heading text-sm font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600">
          {article.title}
        </h3>
        <span className="mt-auto flex items-center gap-1 text-xs text-foreground-400">
          <i className="ri-calendar-line" />
          {article.date}
        </span>
      </div>
    </Link>
  );
}